import { render, staticRenderFns } from "./Facturacion-serviciosadministrativos.vue?vue&type=template&id=d630e258&"
import script from "./Facturacion-serviciosadministrativos.vue?vue&type=script&lang=js&"
export * from "./Facturacion-serviciosadministrativos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports